/** @import { FC } from 'react' */
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, getUserSchema, updateUser } from '@plone/volto/actions';
import { toast } from 'react-toastify';
import { Form, Toast } from '@plone/volto/components';

const EditUserView = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const loading = false;
  const { userId } = useParams();

  const userschema = useSelector((state) => state.userschema || {});
  const user = useSelector((state) => state.users?.user || {});

  const onSubmit = (data) => {
    // We don't want the user to change his login name/username or the roles
    // from this form
    // Backend will complain anyways, but we clean the data here before it does
    delete data.id;
    delete data.username;
    delete data.roles;
    dispatch(updateUser(userId, data));
    toast.success(
      <Toast
        success
        title={'Erfolgreich'}
        content={'Benutzerdaten gespeichert'}
      />,
    );

    history.goBack();
  };

  const onCancel = () => {
    history.goBack();
  };

  useEffect(() => {
    dispatch(getUser(userId));
    dispatch(getUserSchema());
  }, [dispatch, userId]);

  return (
    userschema?.loaded &&
    user?.id === userId && (
      <Form
        formData={user}
        schema={userschema.userschema}
        onSubmit={onSubmit}
        onCancel={onCancel}
        loading={loading}
      />
    )
  );
};

export default EditUserView;
